import { SerializedStyles, css } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import { positionElementFull } from 'src/domains/layouts/styles/Mixin.style';
import { Collapse } from 'src/ui/components/collapse/sports/04/Collapse';
import { Collapse as CollapseUnified } from 'src/ui/components/collapse/sports/05/Collapse';
import { withConfig } from 'src/withConfig';


export const LiveTrackerToggleWrapper = styled(Collapse, { label: 'LiveTrackerToggleWrapper' })`
    text-transform: capitalize;
`;

export const LiveTrackerToggleWrapperUnified = withConfig(theme => styled(CollapseUnified, { label: 'LiveTrackerToggleWrapperUnified' })`
    &[type='default'] {
        text-transform: capitalize;
        font-size: ${theme.star.fontSize.small};
        line-height: ${theme.star.lineHeight[200]};
        background: ${theme.star.unified.liveTracker.bgColor};
        color: ${theme.star.unified.liveTracker.txtColor};
        border-radius: ${theme.star.radius.medium};
        border-bottom: none;

        & [class$='SectionTitle'] {
            font-size: ${theme.star.fontSize.xRegular};
            line-height: 1.428;
            font-weight: ${theme.star.fontWeight.xMedium};
        }
    }
`);

const setLiveTrackerIFrameWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: ${theme.star.padding.medium};
            background: ${theme.star.liveTracker.bgColor};
            margin-top: 8px;
            @media ${theme.star.mediaQuery.tablet} {
                margin: 8px 8px 0;
                border-radius: ${theme.star.radius.medium};
            }
        `;
    }
    if (variant === DefaultComponentVariantType.TERTIARY) {
        return css`
            background: ${theme.star.unified.liveTracker.bgWrapperColor};
            padding: ${theme.star.padding.xMedium};
        `;
    }
    return css``;
};

const setLiveTrackerIFrameContent = (isOpen: boolean, variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.TERTIARY) {
        return css`
            ${(isOpen ? 'padding-bottom: 8px' : '')};
            background: ${theme.star.unified.liveTracker.bgColor};
            border-radius: ${theme.star.radius.medium};
        `;
    }
    return css``;
};

interface LiveTrackerIFrameWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const LiveTrackerIFrameWrapper = withConfig(theme => styled('div', { label: 'LiveTrackerIFrameWrapper' })<LiveTrackerIFrameWrapperPropsType>`
    ${({ variant }): SerializedStyles => setLiveTrackerIFrameWrapper(variant, theme)}
`);

interface LiveTrackerIFrameContentPropsType extends LiveTrackerIFrameWrapperPropsType {
    isOpen: boolean;
}

export const LiveTrackerIFrameContent = withConfig(theme => styled('div', { label: 'LiveTrackerIFrameContent' })<LiveTrackerIFrameContentPropsType>`
    ${({ isOpen, variant }): SerializedStyles => setLiveTrackerIFrameContent(isOpen, variant, theme)}
`);

const renderPreMatchBgImage = (variant: DefaultComponentVariantType | null, bgImage: string | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.TERTIARY) {
        return css`
            background-color: unset;
        `;
    }

    if (bgImage === null) {
        return css``;
    }

    return css`
        background-color: ${theme.star.preMatch.bgColor};
        &::before {
            ${positionElementFull};
            background-image: url(${bgImage}), ${theme.star.preMatch.bgColorSecondary};
            background-position: top center;
            background-repeat: no-repeat;
            background-size: cover;
            content: '';
            position: absolute;
            z-index: ${theme.star.zIndexGlobal.below};
        }
    `;
};

interface LiveTrackerWrapperType extends LiveTrackerIFrameContentPropsType {
    bgImage: string | null;
}

/* Background container for Live tracker */
export const LiveTrackerWrapper = withConfig(theme => styled('div', { label: 'LiveTrackerWrapper' })<LiveTrackerWrapperType>`
    height: ${({ isOpen }): string => (isOpen ? 'auto' : '0')};
    overflow: hidden;
    margin: ${({ isOpen }): string => (isOpen ? '0 8px' : '0')};
    position: relative;
    text-align: center;
    z-index: ${theme.star.zIndexGlobal.base};
    background-color: ${theme.star.preMatch.bgColorTertiary};
    ${({ variant, bgImage }): SerializedStyles => renderPreMatchBgImage(variant, bgImage, theme)};
`);

export const LiveTrackerChevron = styled(ChevronIcon, { label: 'LiveTrackerChevron' })`
    fill: currentcolor;
    width: 12px;
    margin-right: 8px;
`;

interface ReferencePropsType {
    eventId: number;
}

export const ScoreboardWrapper = styled('div', { label: 'ScoreboardWrapper' })<ReferencePropsType>``;
export const SportWidget = styled('div', { label: 'SportWidget' })``; 
